const typographyformEquipServ = {
  text1: 'No added service',
  text2: 'Service Types',
  text3: 'Services done',
  servicesCompletedTab: 'Completed Services',
  draftsTab: 'Drafts',
  draftStartedAt: 'Started on',
  notDone: 'No added service',
  inDelay: (days) => days === 1 ? `Service is ${days} day in delay` : `Service is ${days} days in delay`,
  hasActionsOpenedOrOverdue: (days) => days === 1 ? `Service has ${days} opened or overdue action` : `Service has ${days} opened or overdue actions`,
  zipExport: 'All Services (.ZIP)',
  allEquipmentServicesReplicateExportPDF: 'All Services (.PDF)',
  simplifiedExport: 'Simplified Report (.PDF)',
  allEquipmentServicesReplicateWithAttachmentsExportZip: 'All Services with attachments (.Zip)',
};

export default typographyformEquipServ;
